// extracted by mini-css-extract-plugin
var _1 = "styles_program__Mr+0h";
export { _1 as "program" }
